module.exports = __webpack_public_path__ + "img/1.401d2713.png";